import axios from 'axios';
import {base_url} from './global';

export const httpNF = axios.create({
  baseURL: `${base_url}/notafiscal-ws/servico/`
})